import React from 'react';
import { Navigate } from 'react-router-dom';

import SponsorsSettings from '../../components/misc/SponsorsSettings';
import useSelectedBusiness from '../../../hooks/business/useSelectedBusiness';
import { BusinessRole } from '../../../types/business';
import { Feature, getBusinessSettingsFeatures } from '../../../utils/FeatureUtils';

export default function SponsorsPage(): JSX.Element {
  const business = useSelectedBusiness();
  const features = getBusinessSettingsFeatures(business);
  const canManage =
    business?.role === BusinessRole.OWNER || business?.role === BusinessRole.MANAGER;
  const sponsorsEnabled = features[Feature.SPONSORS] === true;

  if (!sponsorsEnabled || !canManage) {
    return <Navigate to="/settings" replace />;
  }

  return <SponsorsSettings />;
}
